import { render, staticRenderFns } from "./AdmissionExaminationRoomTeacherSave.vue?vue&type=template&id=58ffb18e&"
import script from "./AdmissionExaminationRoomTeacherSave.vue?vue&type=script&lang=js&"
export * from "./AdmissionExaminationRoomTeacherSave.vue?vue&type=script&lang=js&"
import style0 from "./AdmissionExaminationRoomTeacherSave.vue?vue&type=style&index=0&id=58ffb18e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports